import { styled as muiStyled } from '@mui/material'

export const CoolMultiCardCarouselContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  padding: 24px 24px 48px 24px;
  justify-content: center;
  gap: 50px;
  background: #1c2120;
`,
)

export const CoolMultiCardsContainer = muiStyled('div')(
  ({ theme }) => `
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    height: 100%;
    color: #000;
    @media(min-width:768px){
        grid-template-columns: repeat(4, 1fr);
    }
    @media(min-width:992px){
      gap: 35px;
    }
  
  `,
)
